( function( $ ) {
    $(document).ready( function() {
        // Initialize Splide sliders when block is present
        if ( $('.mic-grid').length ) {
            initmicSliders();
        }

        // Re-initialize for block preview in editor
        if ( typeof acf !== 'undefined' ) {
            acf.addAction( 'append', function( $el ) {
                if ( $el.find('.mic-grid').length ) {
                    setTimeout( initmicSliders, 100 );
                }
            });
        }

        function initmicSliders() {
            // Only initialize if both sliders exist
            const $contentSlider = $('.content-slider');
            const $infoSlider = $('.info-slider');
            
            if ( $contentSlider.length && $infoSlider.length ) {
                const contentSlider = new Splide( '.content-slider', {
                    type: 'fade',
                    rewind: true,
                    pagination: false,
                    arrows: false,
                    drag: false,
                    speed: 500,
                    waitForTransition: false
                } );

                const infoSlider = new Splide( '.info-slider', {
                    type: 'fade',
                    rewind: true,
                    pagination: false,
                    arrows: false,
                    drag: false,
                    speed: 500,
                    waitForTransition: false
                } );

                // Sync the two sliders
                contentSlider.sync( infoSlider );
                
                // Mount both sliders
                contentSlider.mount();
                infoSlider.mount();

                // Custom navigation controls using contentSlider as primary
                $('.slider-prev').off('click').on('click', function() {
                    contentSlider.go( '<' );
                });

                $('.slider-next').off('click').on('click', function() {
                    contentSlider.go( '>' );
                });

                // Keyboard navigation
                $(document).off('keydown.micSlider').on('keydown.micSlider', function(e) {
                    if ( $('.mic-grid').is(':visible') ) {
                        if ( e.key === 'ArrowLeft' ) {
                            contentSlider.go( '<' );
                        } else if ( e.key === 'ArrowRight' ) {
                            contentSlider.go( '>' );
                        }
                    }
                });
            }
        }
    } );
} )( jQuery );